// Adds bank-facilities + vulnerability + bulk API helpers
import api from "./api";

export const facilitiesApi = {
  list: (params) => api.get("/bank-facilities", { params }),
  get: (id) => api.get(`/bank-facilities/${id}`),
  create: (f) => api.post("/bank-facilities", f),
  update: (id, f) => api.patch(`/bank-facilities/${id}`, f),
  remove: (id) => api.delete(`/bank-facilities/${id}`),
  assess: (id, scenario = "current") =>
    api.post(`/bank-facilities/${id}/assess`, null, { params: { scenario } }),
  assessAll: (scenario = "current") =>
    api.post("/bank-facilities/assess-all", null, { params: { scenario } }),
  summary: (scenario = "current") =>
    api.get("/bank-facilities/risk/summary", { params: { scenario } }),
};

export const vulnerabilityApi = {
  categorize: () => api.get("/portfolio/vulnerability"),
};

export const bulkApi = {
  uploadBorrowers: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/bulk/borrowers", fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
  uploadCollaterals: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/bulk/collaterals", fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
  uploadFacilities: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/bulk/bank-facilities", fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
};

export const entitiesApi = {
  list: () => api.get("/entities"),
  create: (e) => api.post("/entities", e),
  update: (id, e) => api.patch(`/entities/${id}`, e),
  remove: (id) => api.delete(`/entities/${id}`),
};

export const recoApi = {
  library: () => api.get("/mitigation/library"),
  portfolio: (scenario = "current") => api.get("/recommendations/portfolio", { params: { scenario } }),
  operations: (scenario = "current") => api.get("/recommendations/operations", { params: { scenario } }),
  collateral: (id, scenario = "current") => api.get(`/recommendations/collateral/${id}`, { params: { scenario } }),
  facility: (id, scenario = "current") => api.get(`/recommendations/facility/${id}`, { params: { scenario } }),
};

export const actionPlansApi = {
  list: (params) => api.get("/action-plans", { params }),
  create: (p) => api.post("/action-plans", p),
  update: (id, p) => api.patch(`/action-plans/${id}`, p),
  remove: (id) => api.delete(`/action-plans/${id}`),
  generate: (target_type = "portfolio", scenario = "current") =>
    api.post("/action-plans/generate", null, { params: { target_type, scenario } }),
};

export const reportsApi = {
  boardPack: (scenario = "current", entity_code) =>
    api.get("/reports/board-pack", { params: { scenario, entity_code } }),
  riskCommittee: (scenario = "current", entity_code) =>
    api.get("/reports/risk-committee", { params: { scenario, entity_code } }),
  esgCommittee: (scenario = "current", entity_code) =>
    api.get("/reports/esg-committee", { params: { scenario, entity_code } }),
  tcfd: (scenario = "current", entity_code) =>
    api.get("/reports/tcfd", { params: { scenario, entity_code } }),
  brsr: (scenario = "current", entity_code) =>
    api.get("/reports/brsr", { params: { scenario, entity_code } }),
};
